<div *ngIf="shouldDisplayUi" [ngClass]="{ 'booking--expanded': expanded }" class="booking">
  <ng-container *ngIf="!hasError; else errorCard">
    <div class="d-flex flex-wrap">
      <!-- availability calendar -->
      <div class="mr-5">
        <label class="d-block font-weight-bold mb-2">
          <ng-container
            *ngIf="isEvent; else calendarLabel"
            i18n="Event date caption|The caption above the event date in the booking flow."
            >Event date</ng-container
          >
          <ng-template #calendarLabel i18n="Calendar caption|The caption above the calendar in the booking flow."
            >Select the day</ng-template
          >
        </label>

        <p *ngIf="isEvent; else availabilityCalendar" class="align-with-first-radiobox-at-the-right">
          {{ formattedEventDate(selectedAvailability) }}
        </p>

        <ng-template #availabilityCalendar>
          <app-date-picker
            #calendar
            (dateSelect)="onDateSelect($event)"
            (monthChange)="onMonthChange($event)"
            [dateFilter]="isDateAvailable"
            class="border w-300px"
          ></app-date-picker>

          <div class="mt-2 ml-4 calendar-footer">
            <mat-hint
              *ngIf="!loadingAvailability && availability && availability.length === 0"
              i18n="When the experience is not available for the selected month in the calendar of the booking flow"
              >No availability for this month</mat-hint
            >

            <mat-spinner *ngIf="loadingAvailability" mode="indeterminate" diameter="20"></mat-spinner>
          </div>
        </ng-template>
      </div>

      <!-- experience schedule -->
      <div *ngIf="availability && availabilitiesForPeriod.length > 0" class="mr-5 mb-3">
        <label class="d-block font-weight-bold mb-2">
          <ng-container
            *ngIf="isEvent; else experienceScheduleLabel"
            i18n="Event time caption|Caption before the time of the event in the booking flow"
            >Time</ng-container
          >

          <ng-template
            #experienceScheduleLabel
            i18n="Experience schedule caption|Text before hours available on the selected date in the booking flow"
            >Schedule</ng-template
          >
        </label>

        <mat-radio-group class="d-flex flex-column" [(ngModel)]="selectedAvailability">
          <mat-radio-button
            *ngFor="let availability of availabilitiesForPeriod"
            [value]="availability"
            (click)="onTimeSelected(availability)"
          >
            <span [attr.test-id]="'availability-' + availability.display">{{ availability.display }}</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <!-- experience language -->
      <div *ngIf="product.useRealTimeAvailability && availableLanguages.length > 0" class="mr-5">
        <label class="d-block font-weight-bold mb-2">
          <ng-container i18n="The caption for the list of languages to pick for the experience in the booking flow"
            >Language</ng-container
          >
        </label>

        <mat-radio-group class="d-flex flex-column" [(ngModel)]="selectedLanguageCode">
          <mat-radio-button *ngFor="let languageCode of availableLanguages" [value]="languageCode">
            <span [attr.test-id]="'language-' + languageCode">{{ getLanguageByCode(languageCode) }}</span>
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <!-- experience participants -->
      <div
        *ngIf="(selectedAvailability || !product.useRealTimeAvailability) && availablePricingSchemes"
        class="w-300px"
      >
        <label class="d-block font-weight-bold mb-2">
          <ng-container i18n="The caption before the person counter in the booking flow">Participants</ng-container>
        </label>

        <div *ngFor="let scheme of availablePricingSchemes" class="border px-2 py-1 d-flex mb-2">
          <label class="flex-grow-1 d-flex flex-column">
            <span class="font-weight-bold">{{ scheme.selectedSchema.name }}</span>
            <span class="text-nowrap">{{ scheme.selectedSchema.rate }} {{ product.currency }}/each</span>
          </label>

          <div class="d-flex align-items-center ml-2">
            <button class="border-0 bg-transparent" (click)="decreaseCount(scheme)">
              <i class="d-inline-block fas fa-minus p-2"></i>
            </button>

            <div class="count">{{ scheme.count }}</div>

            <button class="border-0 bg-transparent" (click)="increaseCount(scheme)">
              <i class="d-inline-block fas fa-plus p-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <ng-container *ngIf="selectedAvailability">
        <mat-hint class="mt-1 mr-2">
          {{ remainingCapacity() }} <ng-container i18n="Remaining capacity">seats left</ng-container>
        </mat-hint>
      </ng-container>

      <button
        mat-raised-button
        color="primary"
        class="booking__button"
        (click)="addToShoppingCart()"
        [disabled]="!isAddButtonEnabled()"
        test-id="add-to-cart-button"
      >
        <ng-container
          *ngIf="isSoloMode"
          i18n="Caption of “Checkout” button|Confirmation dialog when the user clicks “Add to cart”"
          >Checkout</ng-container
        >
        <ng-container *ngIf="!isSoloMode" i18n="The “Add to cart” button caption">Add to cart</ng-container>
      </button>
    </div>
  </ng-container>
</div>

<div *ngIf="isSoldOutEvent" class="alert alert-warning m-4 text-center" role="alert">
  <ng-container i18n="Message that we display when all the tickets were sold"
    >We’re sorry, we have sold out.</ng-container
  >
</div>

<mat-spinner *ngIf="isEvent && loadingAvailability" mode="indeterminate" diameter="20" class="mx-auto"></mat-spinner>

<ng-template #errorCard>
  <app-error-card [errorMessage]="errorMessage" (retry)="retry()"></app-error-card>
</ng-template>
